import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {semiFinishedService} from "../../../services/semiFinished-services";


const initialState = {
    semiFinishedArray: [],
    semiFinishedFiltered: [],
    searchActive: false,
    status: null,
    error: null,
    trigger: 0,
}


const getAllSemiFinished = createAsyncThunk(
    'semiFinishedSlice/getAllSemiFinished',
    async (_, {rejectWithValue}) => {
        try {
            return await semiFinishedService.getAllSemiFinished();
        } catch (e) {
            return rejectWithValue(e.response?.data?.message || "Something went wrong");
        }
    }
);


const semiFinishedSlice = createSlice({
    name: "semiFinishedSlice",
    initialState,
    reducers: {
        changeTrigger: (state, action) => {
            state.trigger = state.trigger + 1;
        },
        filteredSemiFinished: (state, action) => {
            const name = action.payload?.toLowerCase().trim();
            if (name) {
                state.searchActive = true;
                state.semiFinishedFiltered = state.semiFinishedArray.filter((obj) =>
                    obj.name?.en?.toLowerCase().includes(name) ||
                    obj.name?.ru?.toLowerCase().includes(name) ||
                    obj.name?.ge?.toLowerCase().includes(name)
                );
            } else {
                state.searchActive = false;
                state.semiFinishedFiltered = [];
            }
        },
        clearSearch: (state) => {
            state.searchActive = false;
            state.semiFinishedFiltered = [];
        },
    },
    extraReducers: builder =>
        builder
            .addCase(getAllSemiFinished.pending, state => {
                state.status = 'Loading';
                state.error = null;
            })
            .addCase(getAllSemiFinished.fulfilled, (state, action) => {
                state.status = 'fulfilled';
                state.semiFinishedArray = action.payload;
            })
            .addCase(getAllSemiFinished.rejected, (state, action) => {
                state.status = 'rejected';
                state.error = action.payload;
            })
});

const {reducer: semiFinishedReducer, actions} = semiFinishedSlice;
const semiFinishedActions = {
    ...actions,
    getAllSemiFinished
}

export {
    semiFinishedReducer,
    semiFinishedActions,
}